import { Typography, List, Box } from '@mui/material';

import CheckedListItem from './CheckedListItem';

const PreviousReleaseCard = ({ agentVersion, releaseDate, changelog }) => {
  return (
    <Box>
      <Typography variant="body2" paddingBottom={1}>
        {agentVersion}
      </Typography>
      <Typography sx={{ paddingBottom: 1 }}>
        Release date:{' '}
        <Typography component="span" variant="oldReleaseCardListItem">
          {releaseDate}
        </Typography>
      </Typography>
      <List>
        {changelog.split('\r\n').map((log, logIndex) => (
          <CheckedListItem key={`log-${logIndex}`}>{log}</CheckedListItem>
        ))}
      </List>
    </Box>
  );
};

export default PreviousReleaseCard;
